// Warning Dismissal Actions
export const DISMISS_WARNING = 'DISMISS_WARNING';
export const WARNING_DISMISSED = 'WARNING_DISMISSED';
export const WARNING_DISMISSAL_FAILED = 'WARNING_DISMISSAL_FAILED';
export const AUTOMATIC_DISMISSAL = 'AUTOMATIC_DISMISSAL';

// Action Creators
export const dismissWarning = (warningType, reason = 'user_dismissed') => ({
  type: DISMISS_WARNING,
  payload: { 
    warningType, 
    dismissedAt: new Date().toISOString(), 
    reason 
  }
});

export const warningDismissed = (warningType, dismissedAt, reason) => ({
  type: WARNING_DISMISSED,
  payload: { warningType, dismissedAt, reason }
});

export const warningDismissalFailed = (error, failedAt) => ({
  type: WARNING_DISMISSAL_FAILED,
  payload: { error, failedAt }
});

export const automaticDismissal = (reason) => ({
  type: AUTOMATIC_DISMISSAL,
  payload: { reason }
});
